define('app/models/guest_checkout_user_address_info',['app/setup'], function(takhfifan) {

  takhfifan.guestCheckoutUserAddressInfo = Backbone.Model.extend({
    validation: {
      'telephone': function (value, key, fields) {
        var pat = new RegExp(/(09)[123]\d+$/);
          if(!pat.test(value) && value.length != 0) {
            return i18n.t('telephone_invalid')
          }
          else if(value.length != 11) {
            return i18n.t('telephone_range')
          }
      },
       'postcode': {
          required: true,
          msg: i18n.t('postcode_missing')
        },

        'city': {
          required: true,
          msg: i18n.t('city_missing')
        },

        'region': {
          required: true,
          msg: i18n.t('region_missing')
        },

        'region_id': {
          required: true,
          msg: i18n.t('region_missing')
        },

        'street': {
          required: true,
          msg: i18n.t('street_missing')
        },

        'firstname': {
          required: true,
          msg: i18n.t('first_name_missing')
        },

        'lastname': {
          required: true,
          msg: i18n.t('last_name_missing')
        },
    },

    save: function(url) {
      var _this = this;
      var json = this.toJSON();
      $.post(url, json).done(function(data){
        if (!_.isNull(data)) {
          if (typeof data == 'string') {
            data = JSON.parse(data);
          }
          if (!_.isNull(data.error) && data.error == 1) {
            takhfifan.eventHub.trigger('guest_customer_address_info:error', [data.message]);
            takhfifan.airbrake.notify(data);
          }
          else {
            data.type = _this.get('cartmode');
            takhfifan.eventHub.trigger('guest_customer_address_info:saved', data);
          }
        }
      }).fail(function(data){
        takhfifan.eventHub.trigger(
          'guest_customer_info:error',
          [data.message]
        );
      });
    }
  });

});

